import { getCarrierPreferences } from './CarrierPreferencesAPI';
export const getCarrierPreferencesByType = async (shipperId, type) => {
    const carrierPreferences = {
        preferred: [],
        excluded: [],
    };
    const carrierPreferenceData = await getCarrierPreferences(shipperId);
    const currentTypePreferences = (carrierPreferenceData || []).filter((p) => p.type === type);
    if (!currentTypePreferences.length) {
        return carrierPreferences;
    }
    carrierPreferences.preferred = currentTypePreferences[0].carriers.map((c) => c.carrier._id.toString());
    carrierPreferences.excluded = currentTypePreferences[0].excluded_carriers.map((c) => c._id.toString());
    return carrierPreferences;
};
export const getPreferredCarrierList = async (shipperId, type) => {
    const carrierPreferenceData = await getCarrierPreferences(shipperId);
    const currentTypePreferences = (carrierPreferenceData || []).filter((p) => p.type === type);
    if (!currentTypePreferences.length) {
        return [];
    }
    return currentTypePreferences[0].carriers.map((c) => c.carrier);
};
